import { ExpandMore as ExpandMoreIcon, ExpandLess } from '@mui/icons-material'
import { ReactElement, useState } from 'react'
import { EngineFitment } from 'interfaces'
import styled from 'styled-components'
import { VehicleModels } from './VehicleModels'

interface VehicleEnginesProps {
  engine: EngineFitment
}

export const VehicleEngines = (props: VehicleEnginesProps): ReactElement => {
  const { engine } = props
  const [open, setOpen] = useState(false)
  return (
    <Row>
      <Wrapper>
        <SubRow>
          <Td clickable onClick={() => setOpen(!open)} width="40%">
            {open && <ExpandLess style={iconStyle} />}
            {!open && <ExpandMoreIcon style={iconStyle} />}
            {engine.engine}
          </Td>
          <Td width="20%">{engine.years}</Td>
          <Td width="40%">{engine.totalApps}</Td>
        </SubRow>
        {open &&
          engine.models.map((model) => (
            <VehicleModels key={model.model + model.years} model={model} />
          ))}
      </Wrapper>
    </Row>
  )
}
const iconStyle = {
  marginRight: '6px',
  color: '#000',
  width: 20,
  height: 20,
  marginLeft: '0.5rem',
}
const Wrapper = styled.div`
  background: #ececea;
`
const Row = styled.div`
  /* Light Gray */
  border: 0 !important;
`

const SubRow = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`
interface TdProps {
  clickable?: boolean
  width?: string
}
const Td = styled.div<TdProps>`
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */

  /* Almost Black */

  color: #050505;
  text-decoration: 'none';
  cursor: ${(p) => (p.clickable ? 'pointer' : 'auto')};
  width: ${(p) => p.width};
  padding-top: 16px;
  padding-bottom: 16px;
`
